import React from 'react';

export function withProviders(providers: any[], jsx: JSX.Element) {
	return providers.reduce((AccumJsx, CurrProvider) => {
		return <CurrProvider>{AccumJsx}</CurrProvider>;
	}, jsx);
}
